module.exports = __webpack_public_path__ + "static/roid3_mens-8d3651ccf75eb3cef2e86b298044d590.png";